import React, { useState } from "react";
import "./Foodclientlanding.css";
import Engineeringpaidclinets from "./Engineeringpaidclinets";
import Engeeniringsubscribedclinets from "./Engeeniringsubscribedclinets";
import Engineeringenquery from "./Engineeringenquery";


const Engineeringservices = () => {
    const [activeTab, setActiveTab] = useState("Enquiry");

    const DummySection = ({ title }) => (
        <div className="dummy-box">
            <h2>{title}</h2>
            <p>This is a dummy section for <strong>{title}</strong>.</p>
            <span>Content will be added later 🚧</span>
        </div>
    );

    const renderComponent = () => {
        switch (activeTab) {
            case "Enquiry":
                return <Engineeringenquery />;
            case "Registration":
                return <Engineeringpaidclinets />;
            case "Subscribed":
                return <Engeeniringsubscribedclinets title="Subscribed" />;

            default:
                return <Engineeringenquery />;
        }
    };

    const tabs = [
        "Enquiry",
        "Registration",
        "Subscribed",

    ];

    return (
        <div className="tabs-wrapper">
            {/* TOP ONE-ROW TABS (ALL SCREENS) */}
            <div className="tabs-row">
                {tabs.map((tab) => (
                    <span
                        key={tab}
                        className={`row-tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </span>
                ))}
            </div>

            {/* CONTENT */}
            <div className="tabs-content">
                {renderComponent()}
            </div>
        </div>
    );
};

export default Engineeringservices;

